import { DomainRule } from '../../types';

export const SendEmailNameRequiredRuleKey = 'sendEmailNameRequired';
export const SendEmailNameCharLimit = 'sendEmailNameCharLimit';

export const SendEmailNameRequiredRule = ({ name }: { name: string }): DomainRule => {
  const trimmedNames = name?.trim();
  if (!trimmedNames) {
    return {
      result: 'fail',
      ruleKey: SendEmailNameRequiredRuleKey,
    };
  }

  const namesTooLong = trimmedNames?.length > 100;
  if (namesTooLong) {
    return {
      result: 'fail',
      ruleKey: SendEmailNameCharLimit,
    };
  }

  return {
    result: 'pass',
    ruleKey: undefined,
  };
};
